import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisV } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import FilterContext from "../../../routes/FilterContext";
import Table from "react-bootstrap/Table";
import { apiMiddleware } from "../../../services/apis/apiMiddleware";
import { BodyAsFormData } from "../../../services/utilities/util";
import { connect } from "react-redux";
function mapStateToProps(state) {
  return { filters: state.selectedFilters };
}
class SummaryTable extends React.Component {
  static contextType = FilterContext;

  state = {
    SummaryTable: {},
    filters: "",
  };

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    var filters;
    if (JSON.stringify(this.props.filters) == "{}") {
      filters = JSON.stringify(this.context.filters);
    } else {
      filters = JSON.stringify(this.props.filters);
    }
    this.state.filters = filters;
    apiMiddleware
      .post("api/edge/office/get_region_summary", BodyAsFormData(filters))
      .then((res) => {
        this.setState({
          SummaryTable: res.data,
        });
      });
  }

  componentDidUpdate() {
    if (this.props.filters != this.state.filters){
      this.setState({ filters: this.props.filters });

      apiMiddleware
        .post(
          "api/edge/office/get_region_summary",
          BodyAsFormData(JSON.stringify(this.props.filters))
        )
        .then((res) => {
          this.setState({
            SummaryTable: res.data,
          });
        });
    }
  }

  render() {
    return (
      <div class="widget widgetRightSideBar widgetGreen text-start mb-4">
        <div class="row">
          <div class="col-lg-9 text-start colorLightBlue widgetTableHeader">
            <p>Summary</p>
          </div>
          <div class="col-lg-3 text-end">
            {/* <Link to="/#" className="colorWhite">
              <FontAwesomeIcon icon={faEllipsisV} />
            </Link> */}
          </div>
          <div class="col-lg-12 mt-4 colorBlack tableCompletion">
            <Table responsive hover>
              <tbody>
                <tr className="">
                  <td># of Assets</td>
                  <td>{this.state.SummaryTable.total_asset}</td>
                </tr>
                <tr className="">
                  <td># of Active Leases</td>
                  <td>{this.state.SummaryTable.total_active_lease}</td>
                </tr>
                <tr className="">
                  <td># of Inctive Leases</td>
                  <td>{this.state.SummaryTable.total_inactive_lease}</td>
                </tr>
                <tr className="">
                  <td># of Sales Transaction</td>
                  <td>{this.state.SummaryTable.total_sales}</td>
                </tr>
                <tr className="">
                  <td>Occupancy</td>
                  <td>{this.state.SummaryTable.avg_occupancy_percent}</td>
                  {/* <td>-</td> */}
                </tr>
                <tr className="">
                  <td>Wt. Avg Current Rent</td>
                  <td>{this.state.SummaryTable.average_passing_rent}</td>
                </tr>
              </tbody>
            </Table>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps)(SummaryTable);
